import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { KEY_PREFIX } from 'marketplace-ui-common/hooks/useSearchParams';
import { useMemo } from 'react';
import { Redirect, generatePath, useLocation } from 'react-router-dom';
import { Paths } from '../../constants/paths';
import { useFilterConfig } from '../../filters/hooks/useFilterConfig';
import { useParsedSearchResultsPathParams } from '../hooks/useParsedSearchResultsPathParams';
import { jsx as _jsx } from "react/jsx-runtime";
export function ProductsSearchResultsProxy({
  productType
}) {
  const parsedPathParams = useParsedSearchResultsPathParams();
  const location = useLocation();
  const {
    AGENT_TEAM,
    CATEGORY,
    loading
  } = useFilterConfig();
  const {
    pathname,
    params
  } = useMemo(() => {
    if (loading) {
      return {
        pathname: Paths.SEARCH_RESULTS,
        params: new URLSearchParams()
      };
    }
    const urlParams = new URLSearchParams(location.search);
    if (productType === 'APP' && parsedPathParams.categorySlug) {
      var _CATEGORY$options$fin;
      const categoryEnumValue = CATEGORY === null || CATEGORY === void 0 || (_CATEGORY$options$fin = CATEGORY.options.find(o => o.slug === parsedPathParams.categorySlug)) === null || _CATEGORY$options$fin === void 0 ? void 0 : _CATEGORY$options$fin.value;
      if (categoryEnumValue && CATEGORY) {
        urlParams.set(`${KEY_PREFIX}${CATEGORY.field}`, categoryEnumValue);
      }

      // The legacy app marketplace used /apps/:slug for both categories and
      // individual app listings. If the slug doesn't match a category, assume
      // it's a listing slug and redirect to the listing details page.
      if (!categoryEnumValue) {
        return {
          pathname: generatePath(Paths.LISTING_DETAILS, {
            listingSlug: parsedPathParams.categorySlug
          }),
          params: new URLSearchParams()
        };
      }
    }
    if (productType === 'AGENT' && parsedPathParams.teamSlug) {
      var _AGENT_TEAM$options$f;
      const teamEnumValue = AGENT_TEAM === null || AGENT_TEAM === void 0 || (_AGENT_TEAM$options$f = AGENT_TEAM.options.find(o => o.slug === parsedPathParams.teamSlug)) === null || _AGENT_TEAM$options$f === void 0 ? void 0 : _AGENT_TEAM$options$f.value;
      if (teamEnumValue && AGENT_TEAM) {
        urlParams.set(`${KEY_PREFIX}${AGENT_TEAM.field}`, teamEnumValue);
      }
    }
    urlParams.set(`${KEY_PREFIX}PRODUCT_TYPE`, productType);
    if (parsedPathParams.page) {
      urlParams.set(`${KEY_PREFIX}page`, parsedPathParams.page.toString());
    }
    return {
      pathname: Paths.SEARCH_RESULTS,
      params: urlParams
    };
  }, [AGENT_TEAM, CATEGORY, loading, location.search, parsedPathParams, productType]);
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium",
      marginBlockStart: "1600"
    });
  }
  const search = params.toString();
  return /*#__PURE__*/_jsx(Redirect, {
    to: {
      pathname,
      search: search ? `?${search}` : ''
    }
  });
}